import styled from '@emotion/styled';
import React, { Fragment } from 'react';
import { AnchorLink } from '../../../components/AnchorLink';

export interface ISection {
  anchor: string;
  label: string;
  el: React.ReactNode;
  noLink?: boolean;
}

const AnchorContainer = styled('div')`
  font-size: ${(p) => p.theme.custom.fontSize.s}px;
  margin-bottom: ${(p) => p.theme.spacing()}px;
`;

export const AnchoredSection = ({ s }: { s: ISection }) => {
  return <div id={s.anchor}>{s.el}</div>;
};

export const AnchorLinks = ({
  sections,
  offset
}: {
  sections: ISection[];
  offset: number;
}) => {
  return (
    <AnchorContainer>
      {sections
        .filter((s) => !s.noLink)
        .map((s, i) => (
          <Fragment key={s.anchor}>
            {i !== 0 && <span> | </span>}
            <AnchorLink anchor={s.anchor} offset={offset}>
              {s.label}
            </AnchorLink>
          </Fragment>
        ))}
    </AnchorContainer>
  );
};

export const AnchoredSections = ({ sections }: { sections: ISection[] }) => {
  return (
    <>
      {sections.map((s) => (
        <AnchoredSection key={s.anchor} s={s} />
      ))}
    </>
  );
};
